import {DOCUMENT} from '@angular/common';
import {Component, EventEmitter, inject, Input, Output} from '@angular/core';

import {
    FormActionButtonsComponent
} from "../../../common/forms/form-action-buttons/form-action-btns.component";
import {
    FormButtonComponent
} from "../../../common/forms/form-button/form-button.component";
import {
    FormItemTextComponent
} from "../../../common/forms/form-item-text/form-item-text.component";
import {SubtitlesService} from "../../../core";

@Component({
  selector: 'api-token-form',
  standalone: true,
    imports: [
        FormActionButtonsComponent,
        FormButtonComponent,
        FormItemTextComponent
    ],
  templateUrl: './api-token-form.component.html',
  styleUrl: './api-token-form.component.scss'
})
export class ApiTokenFormComponent {
    private document = inject(DOCUMENT);
    private subtitles = inject(SubtitlesService);

    @Input({ alias: 'token', required: true })
    set tokenInput(token: string) {
        this.token = token;
    }

    @Output() close = new EventEmitter<void>();

    private _token: string = '';
    copyMessage: string = '';

    labels = {
        description: this.subtitles.setSubtitle(17927),
        close: this.subtitles.setSubtitle(5015),
        copy: this.subtitles.setSubtitle(338),
        copied: this.subtitles.setSubtitle(17928),
        copyError: this.subtitles.setSubtitle(17929),
    };

    get token(): string {
        return this._token;
    }

    set token(token: string) {
        this._token = token;
        this.copyMessage = '';
    }

    selectToken(event: Event): void {
        (event.target as HTMLTextAreaElement).select();
    }

    copyToken(): void {
        this.copyMessage = '';
        this.copyToClipboard(this.token).then(() => {
            this.copyMessage = this.labels.copied;
        }).catch(() => {
            this.copyMessage = this.labels.copyError;
        });
    }

    closeForm(): void {
        this.copyMessage = '';
        this.close.emit();
    }

    private copyToClipboard(text: string): Promise<void> {
        const clipboard = this.document.defaultView?.navigator.clipboard;

        if (clipboard) {
            return clipboard.writeText(text);
        }

        return Promise.reject();
    }
}
